var map = {
	"./AnnouncementsWidget.vue": 58643,
	"./ResourcesWidget.vue": 79519,
	"./StatsWidget.vue": 42504,
	"./TemplateSelectWidget.vue": 2274,
	"./TopCampaignsWidget.vue": 54785,
	"./UpsellBox.vue": 83098,
	"./UpsellWidget.vue": 6033
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70356;